// Test IDs for the Portfolio Budget aggregate page.

export const PORTFOLIO = {
  navLink: 'home-nav-portfolio-budget-link',
  loading: 'portfolio-budget-loading',
  emptyState: 'portfolio-budget-empty-state',
  totalSpend: 'portfolio-budget-total-spend',
  totalRevenue: 'portfolio-budget-total-revenue',
  totalRoas: 'portfolio-budget-total-roas',
  totalFlags: 'portfolio-budget-total-flags',
  roasChart: 'portfolio-budget-roas-chart',
  appsTable: 'portfolio-budget-apps-table',
  appRow: (id) => `portfolio-budget-app-row-${id}`,
};
